import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../styles/signup.css";
import { useDispatch, useSelector } from "react-redux";
import select from "../../assets/select.svg";
import { register } from "../../actions/userAction";
import Message from "../../components/Message";

const DeveloperSignUp = ({ history }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("developer");
  const [message, setMessage] = useState(null);

  const dispatch = useDispatch();

  const userRegister = useSelector((state) => state.userRegister);
  const { loading, error, userInfo } = userRegister;

  // console.log(history);

  useEffect(() => {
    if (userInfo) {
      history.push("/developer/request");
    }
  }, [history, userInfo]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(register(name, email, password, role, history));
  };

  const togglePassword = () => {
    setOpen(!open);
  };

  return (
    <div className="signup">
      {error && <Message variant="danger">{error}</Message>}
      <div className="left">
        <div>
          <div className="logo" href="#">
            wedevelopers
          </div>
        </div>
        <div>
          <h4 className="font-subhead lh-small mt-4 my-2">
            Join our team of developers
          </h4>
          <p className="font-normal">Apply for top software engineering jobs</p>
        </div>
        <div className="mt-2">
          <img className="w-100" src={select} alt="sign up" />
        </div>
      </div>
      <div className="right">
        <div className="text-center logo-sm mt-2">
          <a className="logo" href="/">
            wedevelopers
          </a>
        </div>
        <div className="form-wrapper">
          <h3 className="lh-small font-subhead mb-2">Sign up as a Developer</h3>
          <form onSubmit={submitHandler} className="w-100">
            <div className="mb-1">
              <label>Your full name</label>
              <div className="input">
                <i class="far fa-envelope"></i>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="mb-1">
              <label>Your email</label>
              <div className="input">
                <i class="far fa-envelope"></i>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="mb-1">
              <label>password</label>
              <div className="input">
                <i class="fas fa-lock"></i>
                <input
                  type={open ? "text" : "password"}
                  value={password}
                  placeholder="password"
                  onChange={(e) => setPassword(e.target.value)}
                  minlength="5"
                  required
                />
                <div className="pointer" onClick={togglePassword}>
                  {open ? (
                    <i class="fas fa-eye-slash"></i>
                  ) : (
                    <i class="fas fa-eye"></i>
                  )}
                </div>
              </div>
            </div>
            <div className="mb-1 d-none">
              <label>role</label>
              <div className="input">
                <i class="fas fa-lock"></i>
                <input type="hidden" value={role} />
              </div>
            </div>
            <div className="my-2">
              <button className="d-flex justify-content-center" type="submit">
                {loading ? <div className="spinner"></div> : "SIGN UP"}
              </button>
            </div>
          </form>
          <p className="text-center mb-1">
            By creating an account, I agree to the{" "}
            <Link to="">Terms of Service</Link> and{" "}
            <Link to="">Privacy Policy</Link>.
          </p>
          <p className="text-center mb-1">
            Already have an account? <Link to="/login">Log in</Link>
          </p>
          <p className="text-center">
            <Link to="/employer/signup">Apply As an Employer</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeveloperSignUp;
